module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.3eb5459d.ttf";